import Factory from './tablistOverflow.factory.js';
var _tablistOverflowPropsManager = function tablistOverflowPropsManager(ins) {
  return {
    style: {
      overflow: 'visible'
    },
    className: ins.getSetting('tablistOverflowClass')
  };
};
export { _tablistOverflowPropsManager as tablistOverflowPropsManager };
export default Factory.bind(undefined, function (ins) {
  return {
    tablistOverflowPropsManager: function tablistOverflowPropsManager() {
      return _tablistOverflowPropsManager(ins);
    }
  };
});